<script context="module" lang="ts">
    export enum CtaPlaceholderType {
        NONE = "NONE",
        COLOR_PICKER = "COLOR_PICKER",
        LOGO_UPLOAD = "LOGO_UPLOAD",
        PDF_UPLOAD = "PDF_UPLOAD",
    }
</script>

<script lang="ts">
    export let type: CtaPlaceholderType = null;
    export let onClick: () => void = null;
    export let planName: string = null;
</script>

<div class="placeholder-wrapper">
    {#if type === CtaPlaceholderType.COLOR_PICKER}
        <div class="placeholder">
            <span class="placeholder__colorpicker-circle"></span>
            <span class="placeholder__text">Choose a color</span>

            {#if onClick && planName}
                <button class="placeholder__button" on:click={onClick}>
                    Upgrade to <span class="placeholder__button__bold"
                        >{planName}</span
                    >
                </button>
            {/if}
        </div>
    {:else if type === CtaPlaceholderType.LOGO_UPLOAD}
        <div class="placeholder">
            <svg
                class="placeholder__icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"
                />
            </svg>
            <span class="placeholder__text">Upload a logo</span>

            {#if onClick && planName}
                <button class="placeholder__button" on:click={onClick}>
                    Upgrade to <span class="placeholder__button__bold"
                        >{planName}</span
                    >
                </button>
            {/if}
        </div>
        {#if planName}
            <p class="placeholder-message">
                To customize shared topics upgrade to <b
                    class="placeholder-message__bold">{planName}</b
                > Plan
            </p>
        {/if}
    {:else if type === CtaPlaceholderType.PDF_UPLOAD}
        <div class="button-placeholder">
            <svg
                class="button-placeholder__icon"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"
                />
            </svg>
            <span class="button-placeholder__text">Upload a PDF</span>

            {#if onClick && planName}
                <button class="placeholder__button" on:click={onClick}>
                    Upgrade to <span class="placeholder__button__bold"
                        >{planName}</span
                    >
                </button>
            {/if}
        </div>
    {/if}
</div>

<style>
    .placeholder-wrapper {
        @apply reset flex w-full select-none flex-col items-stretch !important;
    }
    .placeholder {
        @apply reset mt-2 flex h-12 flex-row items-center gap-2 rounded-full border border-solid border-gray-200 bg-gray-100 py-2 pl-4 pr-2 text-gray-300 !important;
    }
    .placeholder__colorpicker-circle {
        @apply reset h-6 w-6 rounded-full bg-gray-400 !important;
    }
    .placeholder__text {
        @apply reset text-sm text-gray-300 !important;
    }
    .placeholder__button {
        @apply reset ml-auto h-8 cursor-pointer rounded-full bg-yellow-300 px-4 py-1 text-center text-xs tracking-tight text-black transition-all hover:scale-105 hover:bg-yellow-400 !important;
    }
    .placeholder__button__bold {
        @apply reset text-xs font-bold tracking-tight text-inherit !important;
    }
    .placeholder__icon {
        @apply reset h-5 w-5 text-gray-300 !important;
    }
    .placeholder-message {
        @apply reset mt-1 text-center text-xs text-gray-300 hover:text-black !important;
    }
    .placeholder-message__bold {
        @apply reset text-xs font-bold text-inherit !important;
    }

    .button-placeholder {
        @apply flex h-12 items-center gap-4 rounded-full bg-neutral-200 py-2 pl-4 pr-2 text-gray-400 !important;
    }
    .button-placeholder__icon {
        @apply h-6 w-6 !important;
    }
    .button-placeholder__text {
        @apply text-lg !important;
    }
</style>
